import { Component, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
export class FormlyWrapperAddons extends FieldWrapper {
   fieldComponent: ViewContainerRef;
/**
 * @param {?} $event
 * @return {?}
 */
addonRightClick($event: any) {
    if (this.to.addonRight.onClick) {
      this.to.addonRight.onClick(this.to, this, $event);
    }
  }
/**
 * @param {?} $event
 * @return {?}
 */
addonLeftClick($event: any) {
    if (this.to.addonLeft.onClick) {
      this.to.addonLeft.onClick(this.to, this, $event);
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'formly-wrapper-addons',
  template: `
    <div class="input-group">
      <div class="input-group-addon"
        *ngIf="to.addonLeft"
        [ngStyle]="{cursor: to.addonLeft.onClick ? 'pointer' : 'inherit'}"
        (click)="addonLeftClick($event)">
        <i [ngClass]="to.addonLeft.class" *ngIf="to.addonLeft.class"></i>
        <span *ngIf="to.addonLeft.text">{{ to.addonLeft.text }}</span>
      </div>
      <ng-template #fieldComponent></ng-template>
      <div class="input-group-addon"
        *ngIf="to.addonRight"
        [ngStyle]="{cursor: to.addonRight.onClick ? 'pointer' : 'inherit'}"
        (click)="addonRightClick($event)">
        <i [ngClass]="to.addonRight.class" *ngIf="to.addonRight.class"></i>
        <span *ngIf="to.addonRight.text">{{ to.addonRight.text }}</span>
      </div>
    </div>
  `,
  styles: [`.input-group formly-field-input { display: inline-flex; }`],
  encapsulation: ViewEncapsulation.None,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'fieldComponent': [{ type: ViewChild, args: ['fieldComponent', {read: ViewContainerRef}, ] },],
};
}

function FormlyWrapperAddons_tsickle_Closure_declarations() {
/** @type {?} */
FormlyWrapperAddons.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FormlyWrapperAddons.ctorParameters;
/** @type {?} */
FormlyWrapperAddons.propDecorators;
/** @type {?} */
FormlyWrapperAddons.prototype.fieldComponent;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
